'use client'

/**
 * WarningLamp — 3D-Warnleuchte (gelb, Polizei-/Pannenwagen-Stil).
 *
 * Eigene SVG-Geometrie, vollstaendig lizenzfrei (kein Asset-Import).
 * Wirkt 3D durch radialen Glanz-Gradient + Boden-Glow. Blinkt synchron
 * mit allen anderen Lampen ueber die globalen CSS-Klassen
 * `fgl-warning-lamp`, `fgl-lamp-halo`, `fgl-lamp-core`.
 *
 * Extrahiert aus breaking-news-ticker.tsx damit die Lampe auch in
 * anderen Komponenten (RecordChaseCard "NEW FGL-RECORD") wiederverwendet
 * werden kann.
 */

export function WarningLamp({ size = 28 }: { size?: number }) {
  const gid = `lampGlow-${Math.random().toString(36).slice(2, 8)}`
  const sid = `lampShine-${Math.random().toString(36).slice(2, 8)}`
  return (
    <span
      className="fgl-warning-lamp inline-block shrink-0"
      style={{ width: size, height: size, lineHeight: 0 }}
      aria-hidden
    >
      <svg viewBox="0 0 32 32" width={size} height={size}>
        <defs>
          <radialGradient id={gid} cx="50%" cy="40%" r="60%">
            <stop offset="0%"   stopColor="#fff8c4" stopOpacity="1" />
            <stop offset="35%"  stopColor="#ffd93b" stopOpacity="1" />
            <stop offset="80%"  stopColor="#c98a07" stopOpacity="1" />
            <stop offset="100%" stopColor="#7a4d00" stopOpacity="1" />
          </radialGradient>
          <radialGradient id={sid} cx="35%" cy="28%" r="35%">
            <stop offset="0%"   stopColor="#ffffff" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
          </radialGradient>
        </defs>
        {/* Halo-Glow (blinkt durch CSS-Klasse) */}
        <circle className="fgl-lamp-halo" cx="16" cy="14" r="13" fill="#ffe14a" opacity="0" />
        {/* Sockel (3D-Boden) */}
        <ellipse cx="16" cy="27" rx="9" ry="2.2" fill="#1a1a1a" opacity="0.55" />
        <rect x="9.5" y="22" width="13" height="4" rx="1.2" fill="#0f0f12" stroke="#3a3a3a" strokeWidth="0.6" />
        <rect x="10.5" y="23" width="11" height="1.2" rx="0.6" fill="#5a5a5a" opacity="0.7" />
        {/* Lampen-Dom (Hauptlicht) */}
        <ellipse cx="16" cy="14" rx="9.5" ry="9" fill={`url(#${gid})`} stroke="#7a4d00" strokeWidth="0.6" />
        {/* Glanzpunkt fuer 3D-Look */}
        <ellipse cx="12.5" cy="10" rx="3.2" ry="2.2" fill={`url(#${sid})`} />
        {/* zentraler Kern (blinkt) */}
        <circle className="fgl-lamp-core" cx="16" cy="14" r="3" fill="#fff7a3" opacity="0.7" />
      </svg>
    </span>
  )
}
